// extracted by mini-css-extract-plugin
export default {"takeSelfie":"SelfiePicturePage_takeSelfie__CqtFB"};